import React, { useState } from 'react';
import './Navigation.css';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navigation">
      <div className="menu-icon" onClick={toggleMenu}>
        <div className={`hamburger ${isMenuOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      
      <div className={`menu-items ${isMenuOpen ? 'open' : ''}`}>
        <a href="/" className="menu-item">Home</a>
        <a href="/mark-six" className="menu-item">Mark Six</a>
        <a href="/fireworks" className="menu-item">Fireworks</a>
      </div>
    </nav>
  );
};

export default Navigation; 